
import { defineComponent, h,watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'redirect',
  setup() {
    // const {params,query} = useRoute();
    // const {path} = params;
    const route = useRoute();
    const router = useRouter();
    const {query} = route;
    watch(() => route.params.path, (val) => {
      // console.log(val)
      if(val) {
        router.replace({ path: '/' + val, query })
      }
    },{immediate: true})
    // useRouter().replace({ path: '/' + path, query })
  },
  render() {
    return h('div')
  },
})
